import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class myCoachService {
  constructor(
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly profileServiceConfigurationService: ProfileServiceConfigurationService
  ) {}

  hasCoachAccess$() {
    return this.profileServiceConfigurationService
      .coachMobileUIEnabled$()
      .pipe(map((coachMobileUIEnabled) => coachMobileUIEnabled && this.oeAppPersonService.getPersonData().coach));
  }

  coachStudyPlan() {
    return this.oeAppPersonService.getPersonData().coachStudyPlan;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/my-coach-section/my-coach.service.ts